import React, {ReactChildren, ReactElement} from "react";
import Button from "../_button";
import cn from "classnames";
import useOnClickOutside from '@/hooks/useOnClickOutside';
import {Dropdown, DropdownMenu, DropdownToggle, DropdownItem} from "reactstrap";
import "./styles";
type Props = {
  active?: boolean;
  children?: ReactChildren | ReactElement;
  label: string | Element;
  name: string;
  onApply: () => void;
  onCancel: () => void;
  onClear?: () => void;
  hideButtons?: boolean;
  setIsOpen?: (isOpen: boolean) => void;
  cy?: string;
};

function FilterForm(props: Props) {
  const [isOpen, setIsOpen] = React.useState(false);
  const ref = React.useRef();
  useOnClickOutside(ref, props.onCancel);

  React.useEffect(() => {
    if (props.setIsOpen) props.setIsOpen(isOpen);
  }, [isOpen]);

  return (
    <Dropdown
      className={cn({
        "editor__filter-form": true,
        "above-scrim": isOpen,
      })}
      data-cy={props.cy}
      isOpen={isOpen}
      ref={ref}
      toggle={() => {
        setIsOpen((io) => !io);
      }}
    >
      <DropdownToggle
        data-cy={props.cy + "-toggle"}
        tag="button"
        className={
          "editor__filter-form__button " +
          (isOpen || props.active
            ? "editor__button editor__button--primary above-scrim"
            : "editor__button editor__button--white")
        }
      >
        {props.label}
      </DropdownToggle>
      <DropdownMenu className={"editor__filter-form__menu"}>
        <div data-cy={props.cy + "-children"}>{props.children}</div>
        {props.hideButtons ? null : (
          <div
            className="editor__filter-form__controls"
            data-cy={props.cy + "-controls"}
          >
            <Button
              cy={props.cy + "-controls-cancel"}
              className="editor__button--white"
              onClick={() => {
                props.onCancel();
                setIsOpen(false);
              }}
            >
              Cancel
            </Button>
            {props.onClear && (
              <Button
                cy={props.cy + "-controls-clear"}
                className="editor__button--white"
                onClick={() => {
                  props.onClear();
                  setIsOpen(false);
                }}
              >
                clear
              </Button>
            )}
            <Button
              cy={props.cy + "-controls-apply"}
              className="editor__button--primary"
              onClick={() => {
                props.onApply();
                setIsOpen(false);
              }}
            >
              Apply
            </Button>
          </div>
        )}
      </DropdownMenu>
    </Dropdown>
  );
}

export default FilterForm;
